<template>
  <v-container fluid>
    <v-card>
      <v-card-title> All Suppliers </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="AllSuppliers"
          :items-per-page="10"
          :item-class="item => !!item.type && 'grey lighten-3'"
        >
          <template v-slot:[`item.more`]="{ item }">
            <base-row-layout>
              <!-- Edite Suppllier Icon -->
              <div>
                <v-btn icon color="primary">
                  <v-icon class="mr-2" @click="SuppEdite(item)">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </div>
              <!-- Show Balce Icon -->
              <div>
                <ShowBalance
                  :ReqURL="`${SuppURL}/balance`"
                  :Title="item.CostName"
                  :query="{ _id: item._id }"
                >
                </ShowBalance>
              </div>
              <!-- Supplietn transaction View Icon -->
              <div>
                <SupplierTran
                  :BaseURL="SuppURL"
                  :Title="item.CostName"
                  :TranInfo="item"
                  :headers="headersTran"
                >
                  <template v-slot:Ref="{ row: item }">
                    <base-row-layout>
                      <!-- Delte Icon -->
                      <!-- {{  }} -->
                      <div
                        v-if="
                          item && item.Ref.toString().search(/^(New)-/) === -1
                        "
                      >
                        <BaseDelete
                          v-if="UsersToken.UserType === 'Admin'"
                          :OnFinish="
                            () => {
                              item.OnSearch(item.fromDate, item.toDate);
                            }
                          "
                          :DelQuery="{ Ref: item.Ref }"
                          DelUrl="/Reports/deleteRef"
                        >
                          <template #title>
                            DELETE
                            <span class="black--text">{{
                              item.Description
                            }}</span>
                          </template>

                          <v-row>
                            <v-col>{{ item.date }}</v-col>

                            <v-col class="black--text" cols="6">{{
                              item.Details
                            }}</v-col>
                            <v-col class="black--text">{{
                              item.Amount && item.Amount.toLocaleString()
                            }}</v-col>
                          </v-row>
                        </BaseDelete>
                      </div>
                      <div>{{ item.Ref }}</div>
                    </base-row-layout>
                  </template>
                </SupplierTran>
              </div>
              <!-- Suppliet payment Icon -->
              <div>
                <supp-payment :BaseUrl="SuppURL" :Info="item"></supp-payment>
              </div>
              <div v-if="item.type">
                <AddToQaas :supp="item" />
              </div>
            </base-row-layout>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <NewSupplier
          :OnEdite="OnEdite"
          :isEditing="isEditing"
          @input="isEditing = $event"
          :OnFinish="Onfinshed"
        ></NewSupplier>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    NewSupplier: () => import("@/components/HQ/Supplier/newSupplier.vue"),
    SuppPayment: () => import("@/components/HQ/Supplier/SuppGroupTran.vue"),
    SupplierTran: () => import("@/components/util/TranSactionView.vue"),
    // SupplierTran: () => import("@/components/util/TranSactionView.vue"),
    ShowBalance: () => import("@/components/util/showBalance.vue"),
    AddToQaas: () => import("./AddToQas"),
  },
  data() {
    return {
      SuppURL: "/supplier",
      isEditing: false,
      loading: false,
      AllSuppliers: [],
      headers: [
        {
          text: "Name",
          align: "left",
          value: "CostName",
          class: "teal darken-3 white--text",
        },
        {
          text: "Phone",
          value: "Contact",
          class: "teal darken-3 white--text",
        },
        {
          text: "Country",
          value: "Country",
          class: "teal darken-3 white--text",
        },
        {
          text: "Email",
          value: "Details",
          class: "teal darken-3 white--text",
        },
        {
          text: "Cash",
          value: "CashType",
          class: "teal darken-3 white--text",
        },

        {
          text: "More",
          value: "more",
          align: "center",
          class: "teal darken-3 white--text",
          sortable: false,
        },
      ],
      headersTran: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Details", value: "Details" },
        { text: "Cash Type", value: "AmountType" },
        { text: "Deposit", value: "deposit" },
        { text: "Withdrawal", value: "withdraw", class: "blue--text" },
        { text: "Reason", value: "Reason" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
      ],
      OnEdite: {},
    };
  },
  computed: {
    ...mapGetters(["UsersToken"]),
  },
  methods: {
    SuppEdite(E_Supp) {
      // console.log(E_Supp);
      this.isEditing = true;
      this.OnEdite = E_Supp;
    },

    loadAllSuppliers() {
      this.loading = true;
      this.$store
        .dispatch("GET_ONLY", this.SuppURL)
        .then(result => {
          // console.log(result);
          this.AllSuppliers = result.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    Onfinshed(result) {
      this.AllSuppliers = result;
      this.isEditing = false;
    },
  },
  mounted() {
    this.loadAllSuppliers();
  },
};
</script>
